import React from "react";
import PropTypes from "prop-types";

import { Form, FormSpy } from "react-final-form";

import SearchFilter from "./SearchFilter";
import RadioFilter from "./RadioFilter";
import RadioFilterIndicator from "./RadioFilterIndicator";

let t = null;

const Filters = ({ filters, values, setValues }) => (
  <Form onSubmit={setValues} initialValues={values}>
    {({ values: finalFormValues, handleSubmit, form }) => (
      <form className="filters" onSubmit={handleSubmit}>
        {Object.keys(values).length > 0 && (
          <>
            <div className="filters__indicators">
              {filters.map((filter) => (
                <RadioFilterIndicator
                  filter={filter}
                  value={values[filter.key]}
                  key={filter.key}
                />
              ))}
              <button
                type="button"
                className="button filters__reset"
                onClick={() => {
                  form.reset({});
                  form.submit();
                }}
              >
                <span className="button__text">Wis alle filters</span>
              </button>
            </div>
          </>
        )}
        <div className="filters__group">
          {filters.map((filter, index) => {
            let filterComponent = null;

            switch (filter.type) {
              case "text":
                filterComponent = (
                  <SearchFilter
                    name={filter.key}
                    label={filter.title}
                    key={filter.key}
                  />
                );
                break;
              case "radios":
                filterComponent = (
                  <RadioFilter
                    values={finalFormValues}
                    name={filter.key}
                    label={filter.title}
                    options={filter.options}
                    expandable={filter.expandable}
                    expandableLimit={filter.expandableLimit}
                    expandableMoreText={filter.expandableMoreText}
                    expandableLessText={filter.expandableLessText}
                    highlighted={index === 1}
                    key={filter.key}
                  />
                );
                break;
              default:
                return false;
            }

            return filterComponent;
          })}
        </div>
        {/*
                <div className="filters__footer">
                    <button
                        className="button"
                        type="submit"
                        onClick={showResults}
                    >
                        Bekijk resultaten
                    </button>
                </div>
                */}
        <FormSpy subscription={{ values: true, dirty: true }}>
          {({ values: formSpyValues, dirty }) => {
            if (dirty) {
              if (typeof formSpyValues.search !== "undefined") {
                if (formSpyValues.search.length > 2) {
                  clearTimeout(t);

                  t = setTimeout(() => {
                    form.submit();
                    form.reset();
                  }, 500);
                }
              } else {
                form.submit();
                form.reset();
              }
            }

            return null;
          }}
        </FormSpy>
      </form>
    )}
  </Form>
);

Filters.propTypes = {
  filters: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  values: PropTypes.shape({}).isRequired,
  setValues: PropTypes.func.isRequired,
  showResults: PropTypes.func.isRequired,
};

export default Filters;
